import React, { useEffect, useState, useMemo } from 'react';
import { Breadcrumb } from 'components';
import {
    Grid,
    Typography,
    InputLabel,
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Stack,
    Snackbar,
    Alert,
    Autocomplete
} from '@mui/material';
import { getCompareSearch, getAllPriceListsfortheTest } from 'services';
import ContentPasteSearchOutlinedIcon from '@mui/icons-material/ContentPasteSearchOutlined';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { debounce } from "lodash";

export const CompareTest = () => {
    const [selectedItem, setSelectedItem] = useState<any>();
    const [testList, setTestList] = useState([] as any[]);
    const [searchValue, setSearchValue] = useState('');
    const [filters, setFilters] = useState({ priceListName: "" });
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [data, setData] = useState<any>();
    const [error, setError] = useState(false);
    const [noTestFound, setNoTestFound] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const debounceFetch = useMemo(
        () =>
            debounce(async (searchValue) => {
                if (searchValue?.length >= 2) {
                    getCompareSearch(searchValue).then((res: any) => {
                        if (res.status === 200) {
                            let itList: any = [];
                            res.data.map((el: any) => {
                                let obj = {
                                    id: el.id,
                                    name: el.name,
                                    label: el.name,
                                }
                                itList.push(obj);
                            });
                            setTestList(res.data);
                        } else {
                            setError(true);
                            setErrorMessage(res.data);
                        }
                    })
                }
            }, 500),
        []
    );

    useEffect(() => {
        if (searchValue) {
            debounceFetch(searchValue)
        } else {
            setTestList([])
        }
        return () => {
            debounceFetch.cancel();
        };
    }, [searchValue, debounceFetch])

    useEffect(() => {
        if (selectedItem?.id) {
            handleSearch(page, filters);
        }
    }, [page])

    const handleSearch = (page: any, filters: any) => {
        if (selectedItem?.id) {
            getAllPriceListsfortheTest(selectedItem?.id, page + 1, filters?.priceListName).then((res: any) => {
                if (res.status === 200) {
                    setData(res.data.priceListsForTheTestList);
                    setTotalPages(res.data.priceListsCount);
                    if (res.data.priceListsForTheTestList.length === 0) {
                        setNoTestFound(true);
                        setFilters({ priceListName: "" });
                    }
                } else {
                    setError(true);
                    setErrorMessage(res.data);
                }
            })
        }
    }

    const handleClear = () => {
        setFilters({ priceListName: "" });
        setPage(0);
        handleSearch(0, { priceListName: "" });
    };

    const handleChangePage = (event: any, newPage: any) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: any) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    let nav: any = [{ name: 'Home', path: '/home' }, { name: 'Catalogue', path: '/home/compareTest' }, { name: 'Compare Test', path: '/home/compareTest' }];
    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '16px 0', cursor: 'pointer' }}>
                <Breadcrumb navList={nav} />
            </div>
            <Typography variant="h6" gutterBottom align='left' mb={2}>
                Compare Test
            </Typography>
            <Grid container spacing={3} mt={5} ml={0}>
                <Grid item xs={2} sm={2} md={2} style={{ paddingTop: 0, paddingLeft: 0 }}>
                    <InputLabel>
                        <Typography variant="subtitle1" gutterBottom>
                            Search Test
                        </Typography>
                    </InputLabel>
                </Grid>
                <Grid item xs={4} sm={4} md={4} style={{ padding: 0 }}>
                    <Autocomplete
                        sx={{ width: '100%', paddingLeft: 0 }}
                        id="controlled-demo"
                        size="small"
                        noOptionsText="No Options"
                        options={testList}
                        onChange={(event: any, newValue: any) => {
                            setSelectedItem(newValue);
                            setFilters({ priceListName: "" });
                        }}
                        onInputChange={(event: any, newInputValue: any) => {
                            setSearchValue(event?.target?.value);
                            if (newInputValue.length === 0) {
                                setSelectedItem(null);
                            }
                        }}
                        filterOptions={(x) => x}
                        getOptionLabel={({ name, shortName }) => {
                            return `${name} (${shortName})`;
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label=""
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={4} sm={4} md={4} style={{ padding: '0 0 0 16px' }}>
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<ContentPasteSearchOutlinedIcon />}
                        onClick={() => handleSearch(page, filters)}
                    >
                        Search
                    </Button>
                </Grid>
            </Grid>
            {totalPages > 0 ?
                <>
                    <Grid container spacing={2} style={{ backgroundColor: '#f5f5f5', marginLeft: '0px', padding: '16px', borderRadius: '6px', width: '100%', marginTop: '32px' }}>
                        <Grid item xs={4} sm={4} md={3} style={{ padding: '0px 8px' }}>
                            <TextField
                                label="Price List Name"
                                variant="outlined"
                                value={filters.priceListName}
                                size="small"
                                sx={{
                                    '.MuiInputLabel-root': {
                                        fontSize: '12px'
                                    },
                                    width: '100%'
                                }}
                                onChange={(e) => setFilters({ ...filters, priceListName: e.target.value })}
                            />
                        </Grid>
                        <Grid item xs={8} sm={8} md={3} style={{ padding: '0px 8px' }}>
                            <Button
                                variant="contained"
                                color="primary"
                                startIcon={<ContentPasteSearchOutlinedIcon />}
                                onClick={() => handleSearch(0, filters)}
                            >
                                Search
                            </Button>
                            <Button
                                variant="outlined"
                                color="primary"
                                startIcon={<ClearOutlinedIcon />}
                                onClick={handleClear}
                                sx={{ marginLeft: '8px' }}
                            >
                                Clear All
                            </Button>
                        </Grid>
                    </Grid>
                    <TableContainer>
                        <Table sx={{ border: '1px solid #ddd', marginTop: '32px' }}>
                            <TableHead style={{ backgroundColor: '#003883' }}>
                                <TableRow>
                                    <TableCell style={{ color: '#fff', width: '150px' }}>Price List Name</TableCell>
                                    <TableCell style={{ color: '#fff', width: '56px' }}>Matrix Type</TableCell>
                                    <TableCell style={{ color: '#fff', width: '56px' }}>Test Price</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data?.map((row) => (
                                    <React.Fragment key={`${row.priceListID}-${row.matrixTypeID}`}>
                                        <TableRow>
                                            <TableCell>{row.priceListName}</TableCell>
                                            <TableCell>{row.matrixTypeName}</TableCell>
                                            <TableCell>{row.testPrice}</TableCell>
                                        </TableRow>
                                    </React.Fragment>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[5, 10]}
                        component="div"
                        count={totalPages}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </> : null}
            <Stack sx={{ width: '100%', marginTop: 2 }} spacing={2}>
                <Snackbar open={error} autoHideDuration={6000} onClose={() => setError(false)}>
                    <Alert severity="warning" onClose={() => setError(false)}>{errorMessage}</Alert>
                </Snackbar>
                <Snackbar open={noTestFound} autoHideDuration={6000} onClose={() => setNoTestFound(false)}>
                    <Alert severity="warning" onClose={() => setNoTestFound(false)}>Test not found!</Alert>
                </Snackbar>
            </Stack>
        </div >
    );
}
